import { COLORS } from '@btime/constants'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../components/presentation/Text'
import { useOpenEditPublicTokenModal } from '../../../utils/routes/modals/modalsActions'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import IconText from '../../../components/presentation/IconText'
import Link from '../../../components/actions/Link'

import { useModalData } from '../../../components/modals/ModalsContext'

const Header = () => {
  const { t } = useTranslation(['publicToken', 'common'])
  const openNewModal = useOpenEditPublicTokenModal()
  const canCreatePublicTokens = useSessionPermission('createPublicToken')
  const entity = useModalData()

  return (
    <FlexGrid>
      <FlexCol flex={1}>
        <Title size="h4">{t('publicToken:title')}</Title>
      </FlexCol>

      {canCreatePublicTokens && (
        <FlexCol>
          <Link onClick={() => openNewModal({ entity })}>
            <IconText
              label={t('common:new')}
              size="small"
              iconSize="1rem"
              iconName="BsFillPlusCircleFill"
              color={COLORS.darkPurple}
              noWrap
            />
          </Link>
        </FlexCol>
      )}
    </FlexGrid>
  )
}

export default Header
